"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { useRouter } from "next/navigation";
import playStore from "../../../public/images/WebsiteImages/Googleplay.png";
import appStore from "../../../public/images/WebsiteImages/AppStore.png";
import Image from "next/image";
import logo from "../../../public/images/WebsiteImages/PandoForce_Logo_teal.png";

const PfFooter = ({ isBookADemo = true }) => {
  const router = useRouter();

  const handleDemo = () => {
    router.push("/schedule-demo");
  };
  return (
    <footer className="bg-[#ebf2f0] py-6 px-6 ">
      <div className="max-w-7xl mx-auto">
        {/* <hr className="border-gray-300 mb-12" /> */}

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8">
          {/* Left Side: Logo + Description */}
          <div className="flex flex-col max-w-md">
            <div className="flex items-center text-[#35a4a6] font-bold text-2xl">
              <Image
                src={logo}
                alt="Farminsta Logo"
                width={120}
                height={32}
                className="object-contain"
              />
            </div>
            <p className="text-gray-600">
              Join our growing community and experience the transformative power of digital business. See our{" "} <br />
              <a href="/terms" className="underline text-primary">
                Terms & Conditions
              </a>{" "}
              and{" "}
              <a href="/privacy" className="underline text-primary">
                Privacy Policy
              </a>
              .
            </p>
          </div>

          {/* Right Side: App Buttons */}
          <div className="flex space-x-4">
            <a
              href="https://app.pandoforce.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block"
            >
              <Image
                src={playStore}
                alt="Get it on Google Play"
                width={140}
                height={40}
                className="h-10 w-auto cursor-pointer"
              />
            </a>

            <a
              href="https://app.pandoforce.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block"
            >
              <Image
                src={appStore}
                alt="Download on the App Store"
                width={140}
                height={40}
                className="h-10 w-auto cursor-pointer"
              />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default PfFooter;
